import { useMemo } from 'react';
import { criticalPORows } from './mppHelpers';
import type { MPPRow } from './types';
import styles from './DailyDashboard.module.css';

export function CriticalPOPanel({
  rows,
  activeModel,
  activeDay,
  onExpand,
  fill = false,
}: {
  rows: readonly MPPRow[];
  activeModel: string;
  activeDay: string;
  onExpand?: () => void;
  /** Stretch the card + scroll area to fill the container (e.g. FloatingPanel). */
  fill?: boolean;
}) {
  const data = useMemo(
    () => criticalPORows(rows, activeModel, activeDay),
    [rows, activeModel, activeDay],
  );
  const orderCount = useMemo(
    () => new Set(data.map((r) => r.order)).size,
    [data],
  );

  return (
    <div className={`${styles.card} ${fill ? styles.cardFill : ''}`}>
      <div className={styles.cardHd}>
        <div>
          <div className={styles.cardTitle}>⚠ Critical-PO orders</div>
          <div className={styles.cardSub}>
            Filled via incoming PO not yet landed
          </div>
        </div>
        <div className={styles.cardHdActions}>
          <span className={`${styles.pill} ${styles.pillWarn}`}>{orderCount} at risk</span>
          {onExpand && (
            <button
              type="button"
              className={styles.expandBtn}
              onClick={onExpand}
              title="Expand"
            >
              ⤢
            </button>
          )}
        </div>
      </div>
      <div className={styles.scrollArea}>
        <table className={styles.dataTable}>
          <thead>
            <tr>
              <th>Order</th>
              <th>SKU</th>
              <th>Day</th>
              <th>Vendor</th>
              <th>Lands</th>
              <th>Conf</th>
            </tr>
          </thead>
          <tbody>
            {data.map((r, i) => (
              <tr key={i}>
                <td>{r.order}</td>
                <td title={r.sku}>{r.sku}</td>
                <td>{String(r.day)}</td>
                <td>{r.vendor}</td>
                <td>{r.lands}</td>
                <td>{r.conf}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
